/**
 * Validates custom metadata input format (key: value)
 */
export function validateCustomMetadata(input: string, existingValues: string[]) {
  const trimmedInput = input.trim();

  if (!trimmedInput) {
    return { isValid: false, error: 'Please enter metadata in "key: value" format' };
  }

  const colonIndex = trimmedInput.indexOf(':');

  if (colonIndex === -1) {
    return { isValid: false, error: 'Missing colon. Use format: "key: value"' };
  }

  if (colonIndex === 0) {
    return { isValid: false, error: 'Key cannot be empty. Use format: "key: value"' };
  }

  if (colonIndex === trimmedInput.length - 1) {
    return { isValid: false, error: 'Value cannot be empty. Use format: "key: value"' };
  }

  const key = trimmedInput.substring(0, colonIndex).trim();
  const value = trimmedInput.substring(colonIndex + 1).trim();

  if (!key || !value) {
    return { isValid: false, error: 'Both key and value are required. Use format: "key: value"' };
  }

  // Check if this exact key:value combination already exists
  const existsInSelected = existingValues.includes(`${key}:${value}`);

  if (existsInSelected) {
    return { isValid: false, error: 'This metadata filter is already selected' };
  }

  return { isValid: true, key, value };
}
